import React from 'react';
import { PriceRow } from '@/seller/components/PriceRow';
import { Trans } from '@lingui/react/macro';
import { ProjectCurrencyDisplay } from '@/seller/components/currency';
import { sumBy } from 'lodash-es';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faSpinner } from '@fortawesome/pro-light-svg-icons';
import theme from './PriceRowEditor.module.scss';

interface PriceRowEditorTotalProps {
    rows: PriceRow[];
}

const PriceRowEditorTotal: React.FC<PriceRowEditorTotalProps> = ({ rows }) => {
    const showTotal = rows.every((x) => !!x.priceCalculation);

    return (
        <span className={theme.totals}>
            <strong>
                <Trans>Total</Trans>:&nbsp;
            </strong>
            {showTotal ? (
                <>
                    <span>
                        <ProjectCurrencyDisplay
                            value={sumBy(
                                rows.map((x) => x.priceCalculation).filter((x) => !!x),
                                'finalPrice'
                            )}
                        />
                    </span>
                    <span>
                        &nbsp;(
                        <ProjectCurrencyDisplay
                            value={sumBy(
                                rows.map((x) => x.priceCalculation).filter((x) => !!x),
                                'basePrice'
                            )}
                        />
                        )
                    </span>
                </>
            ) : (
                <FontAwesomeIcon icon={faSpinner} spin />
            )}
        </span>
    );
};

export default PriceRowEditorTotal;
